/**
 * Upload resource categories. These describe the asset being stored, never the
 * actor's authorization role.
 */
export const UploadAssetKinds = {
  CLINIC_BRANDING: "CLINIC_BRANDING",
  USER_AVATAR: "USER_AVATAR",
  PROFESSIONAL_CARD: "PROFESSIONAL_CARD",
} as const;

export type UploadAssetKind =
  (typeof UploadAssetKinds)[keyof typeof UploadAssetKinds];

export const UPLOAD_ASSET_KIND_VALUES = Object.values(UploadAssetKinds) as [
  UploadAssetKind,
  ...UploadAssetKind[],
];
